import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@gitcenter/shared';

interface AuthState {
    user: User | null;
    sessionId: string | null;
    isAuthenticated: boolean;
    isLoading: boolean;

    // Actions
    setUser: (user: User, sessionId: string) => void;
    logout: () => void;
    setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            sessionId: null,
            isAuthenticated: false,
            isLoading: false,

            setUser: (user, sessionId) => set({
                user,
                sessionId,
                isAuthenticated: true,
            }),

            logout: () => set({
                user: null,
                sessionId: null,
                isAuthenticated: false,
            }),

            setLoading: (isLoading) => set({ isLoading }),
        }),
        {
            name: 'gitcenter-auth',
            partialize: (state) => ({
                user: state.user,
                sessionId: state.sessionId,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
);
